import {
    GET_SHARING_AGREEMENTS,
    GET_SHARING_AGREEMENTS_ORDERED,
    GET_ALL_VISIBILITY_SHARING_AGREEMENTS,
    AGREEMENT_TOGGLE_SPINNER,
    GET_PROVIDER_INFORMATION
} from '../actions/types';
import { updateObject } from '../utility';

const initialState = {
    providerInformation: {},
    sharingAgreements: [],
    orderedAgreements: [],
    visibilitySharingAgreements: {},
    showAgreementSpinner: false,
    isSharingAgreementsLoaded: false,
    currentPage: 1,
    pageSize: 0,
    sortOrder: 'asc',
    sortField: '',
    totalItems: 0,
    snackBarOptions: {
        showSnackbar: false,
        message: '',
        variant: ''
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_SHARING_AGREEMENTS:
            return updateObject(state, {
                sharingAgreements: action.payload,
                isSharingAgreementsLoaded: true
            });
        case GET_SHARING_AGREEMENTS_ORDERED:
            const content = action.payload.items;
            const page = action.payload.currentPage;
            const totalItems = action.payload.totalItems;
            return updateObject(state, {
                sharingAgreements: [...content],
                currentPage: page,
                totalItems: totalItems,
                isSharingAgreementsLoaded: true
            });
        case GET_ALL_VISIBILITY_SHARING_AGREEMENTS:
            return updateObject(state, {
                visibilitySharingAgreements: action.payload
            });
        case AGREEMENT_TOGGLE_SPINNER:
            return updateObject(state, {
                showAgreementSpinner: action.payload
            });
        case GET_PROVIDER_INFORMATION:
            return updateObject(state, {
                providerInformation: action.payload
            });
        default:
            return state;
    }
};
